import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { connect } from "react-redux";
import size from "lodash/size";
import { toast } from "react-toastify";
import { IProject, IAuthenticationState } from "../../../../models/applicationState";
import Select from "react-select";
import HeaderComponent from "../header/header";
import IAuthenticationActions, * as authenticationActions from "../../../../redux/actions/authenticationActions";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import { bindActionCreators } from "redux";

export interface ICreateModelProps extends RouteComponentProps, React.Props<CreateModal> {
    recentProjects: IProject[];
    authenticationAction: IAuthenticationActions;
    projectActions: IProjectActions;
    loggedInUser: IAuthenticationState;
}

function mapStateToProps(state: any) {
    return {
        recentProjects: state.recentProjects,
        loggedInUser: state.loggedInUser,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        projectActions: bindActionCreators(projectActions, dispatch),
        authenticationAction: bindActionCreators(authenticationActions, dispatch),
    };
}

export interface ICreateModelState {
    projectName: string;
    schemaValue: any;
    selectedType: null;     
    selectedTypeValue: any,
  

}

@connect(mapStateToProps, mapDispatchToProps)

export default class CreateModal
    extends React.Component<ICreateModelProps, ICreateModelState> {
    public state: ICreateModelState = {
        projectName: "",
        schemaValue: null,
        selectedType: null,
        selectedTypeValue: null,
    };

    public async componentDidMout() {
        localStorage.removeItem("filesLengthFromModel");
        localStorage.removeItem("trainResult");
    }

    public render() {
        const options = [
            { value: 'generic', label: 'Generic' },
            { value: 'purchase-orders', label: 'Purchase Order' },
            { value: 'invoice', label: 'Invoice' },
            { value: 'id-cards', label: 'ID Cards' },
            { value: 'health-certificates', label: 'Health Certificates' },
        ];
        const ocrOptions = [
            { value: 'od', label: 'OD (Object Detection)' },
            { value: 'im', label: 'IM (Image Classification)' },
            { value: 'ocr', label: 'AI OCR' },
            { value: 'invo', label: 'Invoice (Pre-built)' },
           
        ];

        return (
            <>
                <HeaderComponent
                history={this.props.history}
                match={this.props.match}
                location={this.props.location} />
                <div className="container-fluid animated fadeIn">
                    <div className="row mt-5">
                        <div className="col-lg-2 " />
                        <div className="col-lg-8 ">
                            <div className="card wrap-upload shadow">
                                <div className="create-model">
                                    <div className="row">
                                        <div className="col-lg-3 ">
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className="text-center mt-3">
                                            {/* <label htmlFor="createmodel">Enter name of the model</label> */}
                                            <label htmlFor="createmodel"> <h5> CREATE MODEL</h5></label>
                                        </div>
                                        <div className="mt-2">

                                        </div>
                                        <span> Select Schema</span> <span className="text-info small note"></span>
                                        <Select options={options}
                                            onChange={this.getSchema}
                                            value={this.state.schemaValue}
                                            placeholder="Select"
                                            className="react-select-container zindex-20"
                                            isClearable={true}
                                            theme={(theme) => ({
                                                ...theme,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: "#161a1f",
                                                    primary: "#6b727d",
                                                    neutral0: "#222830",
                                                    neutral20: "#44474c",
                                                    neutral30: "#272c33",
                                                    neutral50: "#fff",
                                                    neutral80: "#9da7b5",
                                                },
                                            })}

                                        />
                                        <span> Select Type</span> <span className="text-info small note"></span>
                                        <Select options={ocrOptions}
                                            value={this.state.selectedTypeValue}
                                            onChange={this.getType}
                                            className="react-select-container z-index-19"
                                            // isClearable={true}
                                            theme={(theme) => ({
                                                ...theme,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: "#161a1f",
                                                    primary: "#6b727d",
                                                    neutral0: "#222830",
                                                    neutral20: "#44474c",
                                                    neutral30: "#272c33",
                                                    neutral50: "#fff",
                                                    neutral80: "#9da7b5",
                                                },
                                            })}

                                        />

                                        <div className="mt-2">
                                            <span> Model Name </span>
                                            <span className="text-info small note">  ( Should not contain Spaces ) <span className="sup">*</span>  </span>
                                            <input type="text" className="form-control" placeholder="Enter model name"
                                                maxLength={20} minLength={4} onChange={(e) => this.getProjectName(e)} name="createModel" />
                                        </div>

                                    </div>
                                    <div className="text-center mt-3 mb-2">
                                        <button type="button" onClick={() => this.setProjectName()} className="btn">
                                            {"Create"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 ">
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-lg-2 ">
                        </div>
                    </div>
                </div>
            </>
        );
    }

    private getProjectName = (event) => {
        this.setState({ projectName: event.target.value });
    }

    private getSchema = (event) => {
        if (event) {
            this.setState({ schemaValue: event });
        } else {
            this.setState({ schemaValue: null });
        }
    }

    private getType = (event) => {
        if (event) {
            this.setState({ selectedTypeValue: event });
        } else {
            this.setState({ selectedTypeValue: null });
        }
    }

/*
    private getType = (type: any) => {
        this.setState({ selectedType: type });
    }*/

    private setProjectName = () => {
        this.props.projectActions.clearStoredExistingModelOcrFiles();
        localStorage.removeItem("filesLengthFromModel");
        localStorage.removeItem("trainResult");
        localStorage.removeItem("project_name");
        localStorage.removeItem("modelName");
        const { projectName } = this.state;
        const regex = /^[a-zA-Z0-9-_-]*$/;
        const regexCheck = regex.test(projectName);
        if (projectName && regexCheck && this.state.selectedTypeValue) {
            let flag;
            if (size(this.props.recentProjects) > 0) {
                const project = this.props.recentProjects.find((project) => {
                    if (project.name === projectName) {
                        flag = true;
                    } else {
                        flag = false;
                    }
                    return flag;
                });
            }
            if (flag) {
                toast.warn("This Project is already Exists ...!", { position: toast.POSITION.TOP_CENTER });
            } else {
                const schemaValue = this.state.schemaValue ? this.state.schemaValue.value : "na";
                const selectedType = this.state.selectedTypeValue ? this.state.selectedTypeValue.value: "na";
                localStorage.setItem("modelName", projectName);

                debugger;
              //  this.props.history.push(`/upload-files/${projectName}/${schemaValue}`);
              if(selectedType=== "ocr")
              {
                this.props.history.push(`/upload-files/${projectName}/${schemaValue}/${selectedType}`);
              }
              else if(selectedType=== "invo")
              {
                this.props.history.push(`/Prebuilt/uploadfiles/${projectName}/${schemaValue}/${selectedType}`);
                            
              }
              else
              {
                this.props.history.push(`/upload-files/${projectName}/${schemaValue}/${selectedType}`);
              }
            }
        } else {
            if (!this.state.selectedTypeValue) {
                toast.warn("Select any type", { position: toast.POSITION.TOP_CENTER });
            } 
            else {
            const toastMsg = !regexCheck ? "Please Enter valid Model name" : "Please enter Model name";
            toast.warn(toastMsg, { position: toast.POSITION.TOP_CENTER });
            }
        }
    }
}
